<div class="sticky-btns">
    <ng-content></ng-content>
</div>
